import { selectTheme } from '@ui-kit/themes';

export default {
  data() {
    return {
      currentTheme: 'sword',
    };
  },
  methods: {
    selectTheme(themeName) {
      selectTheme(themeName);
      this.currentTheme = themeName;
    },
  },
};
